'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LiveProvider = require('./LiveProvider');

var _Editor = require('../Editor');

var _Editor2 = _interopRequireDefault(_Editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LiveEditor = function LiveEditor(props, _ref) {
  var live = _ref.live;
  return _react2.default.createElement(_Editor2.default, _extends({}, props, {
    code: live.code,
    onChange: function onChange(code) {
      live.onChange(code);

      if (typeof props.onChange === 'function') {
        props.onChange(code);
      }
    }
  }));
};

LiveEditor.contextTypes = _LiveProvider.LiveContextTypes;
LiveEditor.propTypes = { onChange: _propTypes2.default.func };

exports.default = LiveEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-live/lib/components/Live/LiveEditor.js
// module id = 508
// module chunks = 35783957827783